import { useState } from "react";
import axios from "axios";

// Import NavBarAdm
import { NavBarAdm } from "../Components/NavBarAdm";

// Import de Context
import { useDataContext } from "../Context/dataContext";

// Import de Hooks
import { useAxiosInterceptors } from "../Hooks/useAxiosInterceptors";
import { useFetchDataUsers } from "../Hooks/useFetchDataUsers";

// Import Iconos
import {
  FaEye,
  FaUserCircle,
  FaPlus,
  FaCheck,
  FaTimes,
  FaClock,
  FaArrowDown,
  FaArrowUp,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";

function Users() {
  // Context and hooks
  useAxiosInterceptors();
  const { url, accessToken } = useDataContext();
  const { users } = useFetchDataUsers(accessToken.access_token);
  const [showReferidosModal, setShowReferidosModal] = useState(false);

  // Estados para manejar los datos del formulario
  const [use_name, setNombre] = useState("");
  const [use_lastName, setLastName] = useState("");
  const [use_dni, setDNI] = useState("");
  const [use_phone, setPhone] = useState("");
  const [use_email, setEmail] = useState("");
  const [use_password, setPassword] = useState("");
  const [use_verif, setVerif] = useState("");
  const [use_amountUsd, setAmountUsd] = useState(0);
  const [use_amountEur, setAmountEur] = useState(0);
  const [use_amountGbp, setAmountGbp] = useState(0);
  const [use_loyaltyEurtoBs, setLoyaltyEurtoBs] = useState(0);

 

  const sendTrustEmail = async () => {
    setLoadingEmail(true);
    setEmailError("");
    setEmailSuccess("");
  
    try {
      await axios.post(`${url}/Mailer/EmailTrustRecordatory`);
      setEmailSuccess("Email de recordatorio enviado correctamente ✅");
    } catch (error) {
      setEmailError(
        error.response?.data?.message || "Error al enviar el email"
      );
    } finally {
      setLoadingEmail(false);
    }
  };
  const [loadingEmail, setLoadingEmail] = useState(false); 
const [emailError, setEmailError] = useState("");
const [emailSuccess, setEmailSuccess] = useState(""); 
  

  // Estados para manejar los datos de los movimientos y directorio
  const [selectedUser, setSelectedUser] = useState(null);
  const [movements, setMovements] = useState([]);
  const [referredBy, setReferredBy] = useState([]);
  const [referralBonus, setReferralBonus] = useState([]);
  const fetchDataByUser = async (user) => {
    try {
      const headers = { Authorization: `Bearer ${accessToken.access_token}` };
  
      const [movementsRes, referredRes, referralBonusRes] = await Promise.allSettled([
        axios.get(`${url}/Movements/user/${user.use_id}`, { headers }),
        axios.get(`${url}/Users/referredBy/${user.use_referrerCode}`, { headers }),
        axios.get(`${url}/ReferralBonus/referrer/${user.use_id}`, { headers }),
      ]);
  
      if (movementsRes.status === "fulfilled") {
        setMovements(movementsRes.value.data);
      } else {
        setMovements([]); 
      }
  
      if (referredRes.status === "fulfilled") {
        setReferredBy(referredRes.value.data);
      } else {
        setReferredBy([]); 
      }
  
      if (referralBonusRes.status === "fulfilled") {
        setReferralBonus(referralBonusRes.value.data);
      } else {
        setReferralBonus([]);
      }
    } catch (err) {
      console.error("Error al cargar datos del usuario:", err);
    }
  };

  // Estado para el buscador
  const [searchQuery, setSearchQuery] = useState("");

  // Estados de modales
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [newUserModalOpen, setNewUserModalOpen] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [showMovementsModal, setShowMovementsModal] = useState(false);

  // Funciones para manejar la búsqueda y filtrado de usuarios
  const handleSearch = (e) => setSearchQuery(e.target.value);
  const filteredUsers = users.filter((user) =>
    `${user.use_name} ${user.use_lastName} ${user.use_email}`
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  // Función para manejar el estado de los usuarios
  const getVerificationIcon = (status) => {
    if (status === "S")
      return <FaCheck style={{ color: "#178f6b", fontSize: "1.1rem" }} />;
    if (status === "N")
      return <FaTimes style={{ color: "#d94343", fontSize: "1.1rem" }} />;
    if (status === "E")
      return <FaClock style={{ color: "#c59100", fontSize: "1.1rem" }} />;
  };

  // Funciones para manejar los datos del formulario
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (selectedUser) {
        await axios.put(
          `${url}/Users/${selectedUser.use_id}`,
          {
            use_name: use_name ? use_name : selectedUser.use_name,
            use_lastName: use_lastName
              ? use_lastName
              : selectedUser.use_lastName,
            use_dni: use_dni ? use_dni : selectedUser.use_dni,
            use_phone: use_phone ? use_phone : selectedUser.use_phone,
            use_email: use_email ? use_email : selectedUser.use_email,
            use_verif: use_verif ? use_verif : selectedUser.use_verif,
            use_loyaltyEurtoBs: use_loyaltyEurtoBs ? use_loyaltyEurtoBs : selectedUser.use_loyaltyEurtoBs,
            use_amountUsd: use_amountUsd
              ? use_amountUsd
              : selectedUser.use_amountUsd,
            use_amountEur: use_amountEur
              ? use_amountEur
              : selectedUser.use_amountEur,
            use_amountGbp: use_amountGbp
              ? use_amountGbp
              : selectedUser.use_amountGbp,
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken.access_token}`,
            },
          }
        );
        setSelectedUser(null);
        closeModal();
        window.location.reload();
      } else {
        await axios.post(
          `${url}/Auth/register`,
          {
            use_name,
            use_lastName,
            use_dni,
            use_phone,
            use_email,
            use_password,
            use_img: "ProfileDefault.png",
            use_verif,
            use_loyaltyEurtoBs,
            use_amountUsd,
            use_amountEur,
            use_amountGbp,
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken.access_token}`,
            },
          }
        );
      }
      setSelectedUser(null);
      closeModal();
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  };

  const closeModal = () => {
    setShowDetailsModal(false);
    setShowEditModal(false);
    setNewUserModalOpen(false);
    setShowImageModal(false);
    setShowMovementsModal(false);
    setSelectedUser(null);
  };

  return (
    <div className="users-page">
      <h2 className="section-title">Gestión de Usuarios</h2>

      <div className="users-actions">
        <input
          type="text"
          placeholder="Buscar por nombre, apellido o correo"
          className="search-input"
          value={searchQuery}
          onChange={handleSearch}
        />
        <button
          className="add-user-btn"
          onClick={() => setNewUserModalOpen(true)}
        >
          <FaPlus /> Añadir Usuario
        </button>
      </div>

      <div className="reminder-email">

  {emailError && <small className="error-text">{emailError}</small>}
  {emailSuccess && <small className="success-text">{emailSuccess}</small>}
  <button
    type="button"
    onClick={sendTrustEmail}
    disabled={loadingEmail} // solo bloquea mientras se envía
    className="reminder-button"
  >
    {loadingEmail ? "Enviando..." : "Enviar email de recordatorio de confianza"}
  </button>

  {emailError && <small className="error-text">{emailError}</small>}
  {emailSuccess && <small className="success-text">{emailSuccess}</small>}

</div>




      <div className="users-table-wrapper">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Perfil</th>
              <th>Nombre</th>
              <th>Correo</th>
              <th>EUR</th>
              <th>GBP</th>
              <th>USD</th>
              <th>Puntos de lealtad</th>
              <th>Verificación</th>
              <th>Detalles</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((user, idx) => (
              <tr key={user.use_id}>
                <td>{idx + 1}</td>
                <td>
                  {user.use_profileImg ? (
                    <img
                      onClick={() => {
                        setSelectedUser(user);
                        setShowImageModal(true);
                      }}
                      src={`${url}/Users/profileImg/${user.use_profileImg}`}
                      alt={`${user.use_name} ${user.use_lastName}`}
                      className="profile-img"
                      style={{ cursor: "pointer" }}
                    />
                  ) : (
                    <FaUserCircle className="profile-icon" />
                  )}
                </td>
                <td>
                  {user.use_name} {user.use_lastName}
                </td>
                <td>{user.use_email}</td>
                <td>€{user.use_amountEur}</td>
                <td>£{user.use_amountGbp}</td>
                <td>${user.use_amountUsd}</td>
                <td>{user.use_loyaltyPoints}</td>
                <td>{getVerificationIcon(user.use_verif)}</td>
                <td>
                  <FaEye
                    className="view-details-icon"
                    onClick={() => {
                      setSelectedUser(user);
                      fetchDataByUser(user);
                      setShowDetailsModal(true);
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* MODALES */}
      {showDetailsModal && selectedUser && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>
              Detalles de {selectedUser.use_name} {selectedUser.use_lastName}
            </h3>
            <p>
              <strong>Teléfono:</strong> {selectedUser.use_phone}
            </p>
            <p>
              <strong>Correo:</strong> {selectedUser.use_email}
            </p>
            <p>
              <strong>DNI:</strong> {selectedUser.use_dni}
            </p>
            {selectedUser.use_loyaltyEurtoBs > 0 && <p>
              <strong>Tasa Especial:</strong> {selectedUser.use_loyaltyEurtoBs}
            </p>}
            <p>
              <strong>€</strong> {selectedUser.use_amountEur} /{" "}
              <strong>£</strong> {selectedUser.use_amountGbp} /{" "}
              <strong>$</strong> {selectedUser.use_amountUsd}
            </p>
            <div className="modal-buttons">
              <button
                className="btn-primary"
                onClick={() => {
                  setShowDetailsModal(false);
                  setShowMovementsModal(true);
                }}
              >
                Movimientos
              </button>
              <button
                className="btn-secondary"
                onClick={() => {
                  setShowDetailsModal(false);
                  setShowReferidosModal(true);
                }}
              >
                Ver Referidos
              </button>

              <button
                className="btn-secondary"
                onClick={() => {
                  setShowDetailsModal(false);
                  setShowEditModal(true);
                }}
              >
                Editar
              </button>
            </div>
            <button onClick={closeModal} className="close-btn">
              Cerrar
            </button>
          </div>
        </div>
      )}

      {showImageModal && selectedUser && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Imagen del Usuario</h3>
            <img
              src={`${url}/Users/profileImg/${selectedUser.use_profileImg}`}
              alt={`${selectedUser.use_name} ${selectedUser.use_lastName}`}
              className="profile-img"
            />
            <button onClick={closeModal} className="close-btn">
              Cerrar
            </button>
          </div>
        </div>
      )}

      {showMovementsModal && selectedUser && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>
              Movimientos de {selectedUser.use_name} {selectedUser.use_lastName}
            </h3>
            <div className="movements-table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Moneda</th>
                    <th>Monto</th>
                    <th>Monto anterior</th>
                    <th>Tipo</th>
                    <th>Referencia</th>
                    <th>Estado</th>
                    <th>Fecha</th>
                    <th>Comentario</th>
                    <th>Comprobante</th>
                  </tr>
                </thead>
                <tbody>
                  {movements.map((move, index) => (
                    <tr key={move.mov_id}>
                      <td>{index + 1}</td>
                      <td>{move.mov_currency}</td>
                      <td>{move.mov_amount}</td>
                      <td>{move.mov_oldCurrency} {move.mov_oldAmount}</td>
                      <td>
                        {move.mov_type === "Deposito" ? (
                          <FaArrowDown color="#2a9d8f" />
                        ) : (
                          <FaArrowUp color="#e53935" />
                        )}
                      </td>
                      <td>{move.mov_ref}</td>
                      <td>
                        <span className={`status-tag ${move.mov_status}`}>
                          {move.mov_status === "R" ? (
                            <>
                              <FaTimesCircle />
                              Rechazado
                            </>
                          ) : move.mov_status === "V" ? (
                            <>
                              <FaCheckCircle />
                              Verificado
                            </>
                          ) : (
                            <>
                              <FaClock />
                              En espera
                            </>
                          )}
                        </span>
                      </td>
                      <td>{move.mov_date}</td>
                      <td>{move.mov_comment || "-"}</td>
                      <td>
                        {move.mov_img && move.mov_img !== "Retiro de Divisa" ? (
                          move.mov_img.endsWith(".pdf") ? (
                            <a
                              href={`${url}/Movements/image/${move.mov_img}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Ver PDF
                            </a>
                          ) : (
                            <button
                              style={{
                                padding: "0.5rem 1.5rem",
                                borderRadius: "8px",
                                border: "none",
                                background: "#2a9d8f",
                                color: "#fff",
                                fontWeight: "bold",
                                cursor: "pointer",
                              }}
                              className="btn btn-view-img"
                              onClick={() =>
                                window.open(
                                  `${url}/Movements/image/${move.mov_img}`,
                                  "_blank"
                                )
                              }
                            >
                              Ver imagen
                            </button>
                          )
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="modal-actions">
              <button
                className="close-btn"
                onClick={() => {
                  setShowMovementsModal(false);
                }}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {showEditModal && selectedUser && (
        <div className="modal-overlay">
          <div className="modal-content edit-user-modal">
            <h3>Editar Usuario</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nombre:</label>
                <input
                  type="text"
                  defaultValue={selectedUser.use_name}
                  onChange={(e) =>
                    setSelectedUser({
                      ...selectedUser,
                      use_name: e.target.value,
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label>Apellido:</label>
                <input
                  type="text"
                  defaultValue={selectedUser.use_lastName}
                  onChange={(e) =>
                    setSelectedUser({
                      ...selectedUser,
                      use_lastName: e.target.value,
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label>DNI:</label>
                <input
                  type="text"
                  defaultValue={selectedUser.use_dni}
                  onChange={(e) =>
                    setSelectedUser({
                      ...selectedUser,
                      use_dni: e.target.value,
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label>Teléfono:</label>
                <input
                  type="text"
                  defaultValue={selectedUser.use_phone}
                  onChange={(e) =>
                    setSelectedUser({
                      ...selectedUser,
                      use_phone: e.target.value,
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label>Correo:</label>
                <input
                  type="email"
                  defaultValue={selectedUser.use_email}
                  onChange={(e) =>
                    setSelectedUser({
                      ...selectedUser,
                      use_email: e.target.value,
                    })
                  }
                />
              </div>
              <select
                defaultValue={selectedUser.use_verif}
                onChange={async (e) => {
                  const newStatus = e.target.value;
                  setSelectedUser({
                    ...selectedUser,
                    use_verif: newStatus,
                  });

                  if (
                    (newStatus === "S" || newStatus === "V") &&
                    (!selectedUser.use_referrerCode || selectedUser.use_referrerCode === "")
                  ) {
                    try {
                      const response = await axios.post(
                        `${url}/Users/${selectedUser.use_id}/referral-code`,
                        {},
                        {
                          headers: {
                            Authorization: `Bearer ${accessToken.access_token}`,
                          },
                        }
                      );

                      setSelectedUser({
                        ...selectedUser,
                        use_referrerCode: response.data.referrerCode, // depende de la respuesta
                        use_verif: newStatus,
                      });
                    } catch (err) {
                      console.log("Error generando código de referido:", err);
                    }
                  }
                }}
              >
                <option value="">Seleccione</option>
                <option value="S">Verificado</option>
                <option value="E">En espera</option>
                <option value="N">Rechazado</option>
              </select>

              <div className="form-group">
                <label>Tasa especial:</label>
                <input
                  type="number"
                  step="any"
                  defaultValue={selectedUser.use_loyaltyEurtoBs}
                  onChange={(e) =>
                    setSelectedUser({
                      ...selectedUser,
                      use_loyaltyEurtoBs: parseFloat(e.target.value),
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label>Saldo en Euros:</label>
                <input
                  type="number"
                  step="any"
                  defaultValue={selectedUser.use_amountEur}
                  onChange={(e) =>
                    setSelectedUser({
                      ...selectedUser,
                      use_amountEur: parseFloat(e.target.value),
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label>Saldo en GBP:</label>
                <input
                  type="number"
                  step="any"
                  defaultValue={selectedUser.use_amountGbp}
                  onChange={(e) =>
                    setSelectedUser({
                      ...selectedUser,
                      use_amountGbp: parseFloat(e.target.value),
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label>Saldo en USD:</label>
                <input
                  type="number"
                  step="any"
                  defaultValue={selectedUser.use_amountUsd}
                  onChange={(e) =>
                    setSelectedUser({
                      ...selectedUser,
                      use_amountUsd: parseFloat(e.target.value),
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label>Código de Referidos:</label>
                <input
                  type="text"
                  value={
                    selectedUser.use_referrerCode !== null &&
                      selectedUser.use_referrerCode !== undefined &&
                      selectedUser.use_referrerCode !== ""
                      ? selectedUser.use_referrerCode
                      : "No posee"
                  }
                  readOnly={
                    !selectedUser.use_referrerCode ||
                    selectedUser.use_referrerCode === "No posee"
                  } // bloquea edición si no tiene código
                  onChange={(e) =>
                    setSelectedUser({
                      ...selectedUser,
                      use_referrerCode: e.target.value,
                    })
                  }
                />
              </div>

              <div className="form-group">
                <label>Puntos de Lealtad:</label>
                <input
                  type="number"
                  step="any"
                  defaultValue={selectedUser.use_loyaltyPoints}
                  onChange={(e) =>
                    setSelectedUser({
                      ...selectedUser,
                      use_loyaltyPoints: parseInt(e.target.value, 10),
                    })
                  }
                />
              </div>
              <div className="modal-buttons">
                <button type="submit" className="btn-success">
                  Guardar Cambios
                </button>
                <button
                  type="button"
                  onClick={closeModal}
                  className="close-btn"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showReferidosModal && selectedUser && (
        <div className="modal-overlay">
          <div className="modal-content referidos-modal">
            <h3>
              Referidos de {selectedUser.use_name} {selectedUser.lastName}
            </h3>

            <p>
              <strong>Euros obtenidos:</strong>{" "}
              {referralBonus.reduce((acc, bonus) => acc + bonus.amount, 0)} €
            </p>
            <p>
              <strong>Puntos de Lealtad:</strong>{" "}
              {selectedUser.use_loyaltyPoints}
            </p>
            <p>
              <strong>Saldo Total:</strong> €{selectedUser.use_amountEur} / £
              {selectedUser.use_amountGbp} / ${selectedUser.use_amountUsd}
            </p>

            <div className="referidos-table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Apellido</th>
                    <th>Código de Referido</th>
                  </tr>
                </thead>
                <tbody>
                  {referredBy?.length > 0 ? (
                    referredBy.map((r) => (
                      <tr key={r.use_id}>
                        <td>{r.use_name}</td>
                        <td>{r.use_lastName}</td>
                        <td>{r.use_referrerCode}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3">Este usuario no tiene referidos aún.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <p>
              <strong>Total de Referidos:</strong> {referredBy.length}
            </p>

            <div className="modal-buttons">
              <button
                type="button"
                onClick={() => {
                  setShowReferidosModal(false);
                }}
                className="close-btn"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {newUserModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Añadir Usuario</h3>
            <form onSubmit={handleSubmit}>
              <label>
                Nombre:
                <input
                  type="text"
                  name="nombre"
                  value={use_name}
                  onChange={(e) => setNombre(e.target.value)}
                  required
                />
              </label>
              <label>
                Apellido:
                <input
                  type="text"
                  name="apellido"
                  value={use_lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                />
              </label>
              <label>
                DNI:
                <input
                  type="text"
                  name="dni"
                  value={use_dni}
                  onChange={(e) => setDNI(e.target.value)}
                />
              </label>
              <label>
                Contraseña:
                <input
                  type="password"
                  name="password"
                  value={use_password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </label>
              <label>
                Teléfono:
                <input
                  type="text"
                  name="telefono"
                  value={use_phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </label>
              <label>
                Correo:
                <input
                  type="email"
                  name="email"
                  value={use_email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </label>
              <label>
                Tasa especial:
                <input
                  type="number"
                  step="any"
                  name="tasaEspecial"
                  value={use_loyaltyEurtoBs}
                  onChange={(e) => setLoyaltyEurtoBs(e.target.value)}
                />
              </label>
              <label>
                Saldo EUR:
                <input
                  type="number"
                  step="any"
                  name="saldoEUR"
                  value={use_amountEur}
                  onChange={(e) => setAmountEur(e.target.value)}
                />
              </label>
              <label>
                Saldo GBP:
                <input
                  type="number"
                  step="any"
                  name="saldoGBP"
                  value={use_amountGbp}
                  onChange={(e) => setAmountGbp(e.target.value)}
                />
              </label>
              <label>
                Saldo USD:
                <input
                  type="number"
                  step="any"
                  name="saldoUSD"
                  value={use_amountUsd}
                  onChange={(e) => setAmountUsd(e.target.value)}
                />
              </label>
              <label>
                Estado de verificación:
                <select
                  name="use_verif"
                  value={use_verif}
                  onChange={(e) => setVerif(e.target.value)}
                >
                  <option>Selecciobe una opción</option>
                  <option value="S">Verificado</option>
                  <option value="E">En espera</option>
                  <option value="N">Rechazado</option>
                </select>
              </label>
              <button type="submit" className="btn btn-success">
                Guardar Usuario
              </button>
            </form>
            <div className="modal-buttons">
              <button onClick={closeModal} className="close-btn">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
      <NavBarAdm />
    </div>
  );
}

export { Users };
